import { combineReducers } from "@reduxjs/toolkit";
import authReducer from '../slices/authSlice'
import profileReducer from "../slices/profileSlice";
import cartReducer from "../slices/cartSlice"
import courseReducer from "../slices/courseSlice"
import viewCourseReducer from "../slices/viewCourseSlice";
// bhot sare reducer ko combine krne ke liye

//creating root reducer for mention reducer
const rootReducer =combineReducers({
    auth:authReducer,
    profile:profileReducer,
    cart:cartReducer,
    viewCourse:viewCourseReducer,
    course:courseReducer,
    
});

export default rootReducer